<div class="card">
  <div class="card-body">
    <h5>Acesso não autorizado ou expirado!</h5>
    <p class="card-text">
        Sua sessão foi encerrada, para um novo acesso utilize o link enviado por e-mail
        <br/><br/>
        Verifique no e-mail a data de expiração do link ou se recebeu um e-mail mais recente com novo link de acesso.
    </p>
  </div>
</div>
